import script from "./ImageWithGradient.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageWithGradient.vue?vue&type=script&setup=true&lang=js"

import "./ImageWithGradient.vue?vue&type=style&index=0&id=1fd2f49e&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd2f49e"]])

export default __exports__